<template>
  <div>


    <CCard>
      <CCardHeader>
        لیست محصولات
        <div>
          <CButton
              color="primary"
              variant="outline"
              square
              size="sm"
              @click="goAddNews()"
          >افزودن محصول
          </CButton>
          <CButton
              color="primary"
              variant="outline"
              square
              size="sm"
              @click="download_product_excel()"
          >دانلود اکسل
          </CButton>
          <CButton
              color="primary"
              variant="outline"
              square
              size="sm"
              @click="open_file_selector()"
          >آپلود اکسل
          </CButton>
        </div>

      </CCardHeader>
      <CCardBody>
        <CTabs>
          <CTab v-for="filter in filters" :title="filter.label">

            <CRow v-if="checkbox_ids.length>0">
              <CCol col="6 col-sm-3">
                <CSelect
                  :options="bulk_edit_items"
                  :value.sync="selected_bulk_edit"
                  />
              </CCol>
              <CCol col="6 col-sm-4" v-if="selected_bulk_edit=='add_to_category'">
                <div class="control_wrapper">
                  <treeselect
                      v-model="value_category"
                      :multiple="false"
                      :flat="true"
                      :normalizer="normalizer_category"
                      :options="options_category"
                      placeholder="دسته بندی محصول را انتخاب کنید"
                  />

                </div>

              </CCol>
              <CCol col="6 col-sm-3">
                <CInputCurrency
                    placeholder="مقدار"
                    v-model="bulk_edit_value"
                />
              </CCol>
              <CCol col="6 col-sm-3">
<CButton
color="primary"
@click="bulk_edit()"
>اعمال تغییرات</CButton>
              </CCol>
            </CRow>
            <CDataTableFixed
                :items="items.filter(x=>x.status==filter.value)"
                :fields="fields"
                column-filter
                :checkbox="true"
                :checkbox_ids.sync="checkbox_ids"
                checkbox_key="id"
                :items-per-page="20"
                hover
                sorter
                pagination
            >
              <template #row="{item,index}">

                <td>
                  <p class="text-muted">{{ index + 1 }}</p>

                </td>

              </template>
              <template #code="{item}">

                <td>
                  <p class="text-muted">{{ item.code }}</p>

                </td>

              </template>
              <template #is_featured="{item}">

                <td>
                  <CIcon name="cil-star" size="xl" v-if="item.is_featured==0"
                         @click.v.native="update_featured_item(item,1),item.is_featured=1"/>
                  <svg v-else @click="update_featured_item(item,0),item.is_featured=0" height="24px" width="24px"
                       version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                       xmlns:xlink="http://www.w3.org/1999/xlink"
                       viewBox="0 0 47.94 47.94" xml:space="preserve">
<path style="fill:limegreen;" d="M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,1.757
	c2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,1.448-0.742,2.285l2.065,12.042
	c0.362,2.109-1.852,3.717-3.746,2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685
	c-1.894,0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528
	c-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,1.944-1.412l5.407-10.956
	C22.602,0.567,25.338,0.567,26.285,2.486z"/>
</svg>
                </td>

              </template>
              <template #type="{item}">

                <td>
                  <p class="text-muted" v-if="item.type==1">فیزیکی</p>
                  <p class="text-muted" v-if="item.type==2">دانلودی</p>
                  <p class="text-muted" v-if="item.type==3">ویدئویی</p>

                </td>

              </template>
              <template #price="{item}">

                <td>
                  <div style="display: inline-flex;min-width: 130px" v-if="item.prices.length==1">
                    <CInputCurrency class="pb-0" v-model="item.prices[0].price"/>
                    <CButton size="sm" ourlined color="success" @click="update_product_price(item)">
                      <CIcon name="cil-check"/>
                    </CButton>
                  </div>

                  <div style="display: inline-flex;min-width: 100px" v-if="item.prices.length==1">
                    قیمت بعد از تخفیف

                    <CInputCurrency class="pb-0" v-model="item.prices[0].off_price"/>

                  </div>

                </td>

              </template>

              <template #stock="{item}">

                <td>
                  <div style="display: inline-flex;min-width: 100px" v-if="item.prices.length==1">
                    <CInputCurrency class="pb-0" v-model="item.prices[0].stock"/>
                    <CButton size="sm" ourlined color="success" @click="update_product_stock(item)">
                      <CIcon name="cil-check"/>
                    </CButton>
                  </div>

                </td>

              </template>


              <template #image="{item}">


                <td>
                  <CImg v-if="item.gallery.length>0" width="50px" height="50px" v-bind:src="item.gallery[0].image"/>
                </td>

              </template>

              <template #operation="{item,index}">
                <td class="py-2">
                  <CButton
                      color="warning"
                      variant="outline"
                      square
                      class="m-1"
                      size="sm"
                      @click="editDetails(item,index)"
                  >
                    <CIcon name="cil-pencil" size="sm"/>
                  </CButton>
                  <CButton
                      color="primary"
                      variant="outline"
                      square
                      class="m-1"
                      size="sm"
                      @click="editDetailsClone(item,index)"
                  >
                    <CIcon name="cil-clone" size="sm"/>
                  </CButton>
                  <CButton
                      color="danger"
                      variant="outline"
                      square
                      class="m-1"
                      size="sm"
                      @click="delete_item_dialog(item)"
                  >
                    <CIcon name="cil-trash" size="sm"/>
                  </CButton>
                  <CButton
                      :color="item.status==1?'danger':'success'"
                      variant="outline"
                      square
                      class="m-1"
                      size="sm"
                      @click="deactive_product(item)"
                  >
                    <CIcon v-if="item.status==1" name="cil-low-vision" size="sm"/>
                    <CIcon v-if="item.status==2" name="eye" size="sm"/>
                  </CButton>
                  <CButton
                      color="info"
                      variant="outline"
                      square
                      class="m-1"
                      size="sm"
                      @click="go_bundle_price(item)"
                  >
                    <CIcon name="cil-dollar" size="sm"/>
                  </CButton>
                  <CButton
                      color="info"
                      variant="outline"
                      square
                      class="m-1"
                      size="sm"
                      @click="go_additional_values(item)"
                  >
                    <CIcon name="cil-list" size="sm"/>
                  </CButton>
                  <CButton
                      color="info"
                      variant="outline"
                      square
                      class="m-1"
                      size="sm"
                      @click="go_comments(item)"
                  >
                    <CIcon name="cil-comment-bubble" size="sm"/>
                  </CButton>
                                    <CButton
                                        color="primary"
                                        variant="outline"
                                        square
                                        class="m-1"
                                        size="sm"
                                        @click="go_show_product(item)"
                                    >نمایش
                                    </CButton>

                </td>
              </template>


            </CDataTableFixed>

          </CTab>

        </CTabs>
      </CCardBody>

    </CCard>

    <CInputFile
        custom
        horizontal
        id="excel_uploader_file"
        v-show="false"

        v-on:change="handleFileUpload"
    />
  </div>

</template>

<script>
import axios from "axios";
import {bus} from "../../main";
import xlsx from "json-as-xlsx";
import readXlsxFile from 'read-excel-file'
import Treeselect from "@riophae/vue-treeselect";


export default {
  name: 'Login',
  components: {
    Treeselect
    // Use the <ckeditor> component in this view.
    // ckeditor: CKEditor.component
  },
  data() {
    return {
      bulk_edit_items:[
        {label:'انتخاب کنید',value:''},
        {label:'افزایش قیمت (مبلغ)',value:'increase_price'},
        {label:'افزایش قیمت (درصد)',value:'increase_percent'},
        {label:'کاهش قیمت (مبلغ)',value:'decrease_price'},
        {label:'کاهش قیمت (درصد)',value:'decrease_percent'},
        {label:'اعمال تخفیف (مبلغ)',value:'off_price'},
        {label:'اعمال تخفیف (درصد)',value:'off_percent'},
        {label:'افزودن به دسته بندی',value:'add_to_category'},
        {label:'حذف انتخابی ها',value:'delete_selected'},
      ],
      selected_bulk_edit:'',
      bulk_edit_value:'',
      confirm_delete_name: new Date().getTime() + "_" + this.$vnode.tag,
      checkbox_ids:[],
      name: '',
      file: '',
      color: '',
      previewImage: '',
      description: '',
      excel_file: null,
      items: [],
      fields: [
        {key: 'row', label: '#', _style: 'width:3%', sorter: false, filter: false},
        {key: 'image', label: 'تصویر', _style: 'width:7%'},
        {key: 'name', label: 'عنوان', _style: 'width:25%'},
        {key: 'code', label: 'کد', _style: 'width:7%'},
        // {key: 'type', label: 'نوع', _style: 'width:7%;'},
        {key: 'price', label: "قیمت", _style: 'width:13%;'},
        {key: 'stock', label: "موجودی", _style: 'width:7%;'},
        {key: 'is_featured', label: "★", _style: 'width:5%;'},
        {key: 'operation', label: 'عملیات', _style: 'width:12%;'},

      ],
      filters: [
        {label: 'محصولات فعال', value: 1},
        {label: 'محصولات غیر فعال', value: 2},
      ],
      details: [],
      collapseDuration: 0,
      options_category: [],
      value_category: null,

      normalizer_category(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,
        }
      },
      status_form: 0
    }
  },
  mounted() {
    this.get_categories();

    this.get_data();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == 'true') {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  },
  watch: {
    '$route.params.cat_id': function (id) {
      this.get_data();
    },

  },
  methods: {
    get_categories() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/product/get_categories_with_children', formData, {}).then(function (response) {
        var content_cats = response.data;
        self.options_category = content_cats.orders;
      })
          .catch(function (error) {
            console.log(error);
          });

    },
    download_product_excel() {
      var self = this;
      const formData = new FormData();
      var url = '/api/admin/product/get_products';
      if (this.$route.params.cat_id) {
        url = '/api/admin/product/get_products_by_cat'
        formData.append("cat_id", this.$route.params.cat_id)
      }
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.error == false) {

          var pros = []
          content_data.items.forEach(function (val,index) {

            pros.push({
              id:val.id,
              name:val.title.title,
              code:val.code,
              price:val.prices[0].price,
              off_price:val.prices[0].off_price,
              stock:val.prices[0].stock,
            })
          })
          const fileName = "Products"
          let settings = {
            fileName: fileName, // Name of the resulting spreadsheet
            extraLength: 3, // A bigger number means that columns will be wider
            writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
            writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
            RTL: true, // Display the columns from right-to-left (the default value is false)
          }
          let data_json = [
            {
              sheet: "Sheet1",
              columns: [
                { label: "id", value: "id" }, // Top level data
                { label: "name", value: "name" }, // Top level data
                { label: "code", value: "code" }, // Top level data
                { label: "price", value: "price" }, // Top level data
                { label: "off_price", value: "off_price" }, // Top level data
                { label: "stock", value: "stock" }, // Top level data
              ],
              content: pros,
            },
          ]

          xlsx(data_json, settings)

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },

    editDetails(item, index) {
      this.$router.push({path: "/dashboard/products/edit/" + item.id});

    },
    editDetailsClone(item, index) {
      this.$router.push({path: "/dashboard/products/clone/" + item.id});

    },
    go_bundle_price(item, index) {
      this.$router.push({path: "/dashboard/products/bundle_price/" + item.id});
    },
    go_additional_values(item, index) {
      this.$router.push({path: "/dashboard/products/additional-relation/" + item.id});
    },
    go_comments(item, index) {
      this.$router.push({path: "/dashboard/products/comments/" + item.id});
    },
    go_show_product(item) {
      window.open(localStorage.getItem("web_address") + "product/" + item.title.slug, "_blank");
    },
    upload_excel_items(items) {
      var url = '/api/admin/product/update_product_excel';
      var self = this

      var formData = new FormData();
      formData.append("items", JSON.stringify(items))
      axios.post(url, formData, {}).then(function (response) {
        self.$root.modal_component.show_api_response_modals(response);
        self.get_data()

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    bulk_edit() {
      var url = '/api/admin/product/bulk_edit_products';
      var self = this

      var formData = new FormData();
      formData.append("op", this.selected_bulk_edit)
      formData.append("value", this.bulk_edit_value)
      formData.append("ids", this.checkbox_ids)
      formData.append("category", this.value_category)
      axios.post(url, formData, {}).then(function (response) {
        self.$root.modal_component.show_api_response_modals(response);
        self.get_data()

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    update_product_price(item) {
      var url = '/api/admin/product/update_product_price';
      var self = this

      var formData = new FormData();
      formData.append("product_id", item.id)
      formData.append("price", item.prices[0].price.replace(/,/g, ''))
      formData.append("off_price", item.prices[0].off_price.replace(/,/g, ''))
      axios.post(url, formData, {}).then(function (response) {
        // self.$root.modal_component.show_api_response_modals(response);


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    update_product_stock(item) {
      var url = '/api/admin/product/update_product_stock';
      var self = this
      var formData = new FormData();
      formData.append("product_id", item.id)
      formData.append("stock", item.prices[0].stock.replace(/,/g, ''))
      axios.post(url, formData, {}).then(function (response) {
        // self.$root.modal_component.show_api_response_modals(response);


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    update_featured_item(item, status) {
      var url = '/api/admin/product/update_product_featured';
      var self = this
      var formData = new FormData();
      formData.append("product_id", item.id)
      formData.append("status", status)
      axios.post(url, formData, {}).then(function (response) {
        // self.$root.modal_component.show_api_response_modals(response);
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_data() {
      var self = this;

      var formData = new FormData();
      var url = '/api/admin/product/get_products';
      if (this.$route.params.cat_id) {
        url = '/api/admin/product/get_products_by_cat'
        formData.append("cat_id", this.$route.params.cat_id)
      }
      axios.post(url, formData, {}).then(function (response) {

        var contents = response.data;

        self.items = contents.items;
        self.items.forEach(function (val) {
          val.name = val.title.title
        })

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    goAddNews() {

      this.$router.push({path: '/dashboard/products/create'});
    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal('اخطار', "آیا مایل به حذف این ردیف هستید؟", ['تایید'], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/product/delete_product";


      formData.append('post_id', this.status_form);

      axios.post(url, formData, {}).then((response) => {
        self.$root.modal_component.show_api_response_modals(response);

        self.status_form = 0;

        self.get_data();


      })
          .catch(function (error) {

            console.log(error);
          });
    },
    deactive_product(item) {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/product/deactive_product";
      if (item.status == 2) {
        url = "/api/admin/product/active_product";
      }

      formData.append('post_id', item.id);

      axios.post(url, formData, {}).then((response) => {
        self.$root.modal_component.show_api_response_modals(response);

        self.status_form = 0;

        self.get_data();


      })
          .catch(function (error) {

            console.log(error);
          });
    },
    handleFileUpload(files, e) {
      console.log("handle upload")
      var myfile = e.target.files[0];
      if (myfile == null) {
        return
      }

      // e.target.value = '';
      // e.target.files = '';
      this.excel_file = myfile

      this.read_ecel()
      // e.target = null

    },
    read_ecel() {
      var self= this
      try {
        if (this.excel_file) {
          readXlsxFile(this.excel_file).then((rows) => {
            // `rows` is an array of rows
            var excel_fields = []
            var excel_items = []
            if (rows.length > 0) {
              for (var i = 0; i < rows.length; i++) {
                var row = rows[i];
                if (i == 0) {
                  row.forEach(function (val, index) {
                    excel_fields.push({label: val, key: val})
                  })
                } else {
                  var item = {};
                  row.forEach(function (val, index) {
                    item[rows[0][index]] = val
                  })
                  excel_items.push(item)
                }


              }

            }
            self.upload_excel_items(excel_items);
console.log("read excel",excel_items,excel_fields);
            // each row being an array of cells.
          }).catch((rows) => {
            console.log("invalid file 1")
            alert('Invalid File')
          })
        }

      } catch (e) {
        console.log("invalid file 2")

        alert('Invalid File');
      }

    },

    open_file_selector() {
      document.getElementById("excel_uploader_file").click()
    },
  }
}


</script>
